import { $ } from "@olton/dom";

globalThis.$ = $;
globalThis.Dom = $;
